(function () {
  'use strict';

  var POPUP_ID = 'ogc-email-popup';

  /*
   * Popup timing
   */
  var SHOW_DELAY = 10000;

  /*
   * If dismissed, do not show again for 7 days.
   */
  var DISMISS_DURATION =
    7 * 24 * 60 * 60 * 1000;

  /*
   * LocalStorage keys.
   */
  var STORAGE_DISMISSED =
    'ogcEmailPopupDismissed';

  var STORAGE_CONVERTED =
    'ogcEmailPopupConverted';

  /*
   * Pages where the popup should never
   * automatically appear.
   */
  var EXCLUDED_PATHS = [
    '/pages/promotions',
    '/pages/contact',
    '/pages/pricing',
    '/pages/free-business-tools',
    '/pages/free-online-invoice-generator',
    '/pages/free-bulk-qr-code-generator',
    '/pages/free-online-events-badge-maker',
    '/pages/free-email-verification-tool',
    '/pages/free-online-payslip-generator-template',
    '/pages/online-sales-commission-calculator',
    '/checkout',
    '/cart',
    '/blogs'
  ];

  function init() {
    var popup =
      document.getElementById(POPUP_ID);

    if (!popup) return;

    if (popup.dataset.ogcPopupReady === 'true') {
      return;
    }

    popup.dataset.ogcPopupReady = 'true';

    var closeButtons =
      popup.querySelectorAll(
        '[data-ogc-popup-close]'
      );

    var copyButton =
      popup.querySelector(
        '[data-ogc-copy-coupon]'
      );

    var successState =
      popup.querySelector(
        '[data-ogc-popup-success]'
      );

    var openTimer = null;

    /*
     * -------------------------------------------------------
     * Open popup
     * -------------------------------------------------------
     */
    function openPopup(options) {
      options = options || {};

      if (openTimer) {
        window.clearTimeout(openTimer);
        openTimer = null;
      }

      popup.classList.add('is-open');

      popup.setAttribute(
        'aria-hidden',
        'false'
      );

      document.documentElement.classList.add(
        'ogc-popup-open'
      );

      document.body.classList.add(
        'ogc-popup-open'
      );
    }

    /*
     * -------------------------------------------------------
     * Close popup
     * -------------------------------------------------------
     */
    function closePopup(rememberDismissal) {
      popup.classList.remove('is-open');

      popup.setAttribute(
        'aria-hidden',
        'true'
      );

      document.documentElement.classList.remove(
        'ogc-popup-open'
      );

      document.body.classList.remove(
        'ogc-popup-open'
      );

      if (rememberDismissal !== false) {
        try {
          localStorage.setItem(
            STORAGE_DISMISSED,
            Date.now().toString()
          );
        } catch (e) {}
      }
    }

    /*
     * -------------------------------------------------------
     * Current URL helpers
     * -------------------------------------------------------
     */
    function normalisePath(path) {
      if (!path) return '/';

      if (
        path.length > 1 &&
        path.charAt(path.length - 1) === '/'
      ) {
        return path.slice(0, -1);
      }

      return path;
    }

    function isExcludedPage() {
      var currentPath =
        normalisePath(
          window.location.pathname
        );

      return EXCLUDED_PATHS.some(
        function (excludedPath) {
          return (
            currentPath === excludedPath ||
            currentPath.indexOf(
              excludedPath + '/'
            ) === 0
          );
        }
      );
    }

    /*
     * -------------------------------------------------------
     * Storage helpers
     * -------------------------------------------------------
     */
    function hasConverted() {
      try {
        return (
          localStorage.getItem(
            STORAGE_CONVERTED
          ) === 'true'
        );
      } catch (e) {
        return false;
      }
    }

    function markConverted() {
      try {
        localStorage.setItem(
          STORAGE_CONVERTED,
          'true'
        );

        localStorage.removeItem(
          STORAGE_DISMISSED
        );
      } catch (e) {}
    }

    function dismissedRecently() {
      var dismissedAt = 0;

      try {
        dismissedAt = Number(
          localStorage.getItem(
            STORAGE_DISMISSED
          )
        );
      } catch (e) {
        return false;
      }

      if (!dismissedAt) {
        return false;
      }

      return (
        Date.now() - dismissedAt <
        DISMISS_DURATION
      );
    }

    /*
     * -------------------------------------------------------
     * Detect Shopify customer-form success
     *
     * The Liquid success block is the most reliable
     * indication because Shopify has rendered it
     * after accepting the form.
     * -------------------------------------------------------
     */
    if (successState) {
      markConverted();

      /*
       * Show the success popup immediately,
       * even though future visits are now excluded.
       */
      openPopup();

      cleanNewsletterUrl();

      setupCopyButton();

      setupClosing();

      return;
    }

    /*
     * -------------------------------------------------------
     * Standard opening rules
     * -------------------------------------------------------
     */

    /*
     * Never automatically display on excluded pages.
     */
    if (isExcludedPage()) {
      setupClosing();
      setupCopyButton();

      return;
    }

    /*
     * Visitor already claimed the offer.
     */
    if (hasConverted()) {
      setupClosing();
      setupCopyButton();

      return;
    }

    /*
     * Visitor dismissed it within last 7 days.
     */
    if (dismissedRecently()) {
      setupClosing();
      setupCopyButton();

      return;
    }

    /*
     * Eligible visitor:
     * show after 10 seconds.
     */
    openTimer = window.setTimeout(
      function () {
        openPopup();
      },
      SHOW_DELAY
    );

    setupClosing();
    setupCopyButton();

    /*
     * -------------------------------------------------------
     * Close events
     * -------------------------------------------------------
     */
    function setupClosing() {
      closeButtons.forEach(
        function (button) {
          if (
            button.dataset.ogcCloseReady ===
            'true'
          ) {
            return;
          }

          button.dataset.ogcCloseReady =
            'true';

          button.addEventListener(
            'click',
            function () {
              closePopup(true);
            }
          );
        }
      );

      document.addEventListener(
        'keydown',
        function (event) {
          if (
            event.key === 'Escape' &&
            popup.classList.contains(
              'is-open'
            )
          ) {
            closePopup(true);
          }
        }
      );
    }

    /*
     * -------------------------------------------------------
     * Copy coupon
     * -------------------------------------------------------
     */
    function setupCopyButton() {
      if (!copyButton) return;

      if (
        copyButton.dataset.ogcCopyReady ===
        'true'
      ) {
        return;
      }

      copyButton.dataset.ogcCopyReady =
        'true';

      copyButton.addEventListener(
        'click',
        function () {
          var card =
            copyButton.closest(
              '[data-ogc-coupon-card]'
            );

          var code =
            card &&
            card.querySelector(
              '[data-ogc-coupon-code]'
            );

          if (!code) return;

          var value =
            code.textContent.trim();

          var copiedLabel =
            copyButton.dataset.copiedLabel ||
            'Copied!';

          var copyLabel =
            copyButton.dataset.copyLabel ||
            'Copy code';

          function showCopied() {
            copyButton.textContent =
              copiedLabel;

            window.setTimeout(
              function () {
                copyButton.textContent =
                  copyLabel;
              },
              1800
            );
          }

          if (
            navigator.clipboard &&
            window.isSecureContext
          ) {
            navigator.clipboard
              .writeText(value)
              .then(showCopied)
              .catch(function () {
                fallbackCopy(
                  value,
                  showCopied
                );
              });
          } else {
            fallbackCopy(
              value,
              showCopied
            );
          }
        }
      );
    }

    function fallbackCopy(
      value,
      callback
    ) {
      var textarea =
        document.createElement(
          'textarea'
        );

      textarea.value = value;

      textarea.setAttribute(
        'readonly',
        ''
      );

      textarea.style.position =
        'fixed';

      textarea.style.opacity = '0';

      textarea.style.pointerEvents =
        'none';

      document.body.appendChild(
        textarea
      );

      textarea.select();

      try {
        document.execCommand('copy');

        if (callback) {
          callback();
        }
      } catch (e) {}

      document.body.removeChild(
        textarea
      );
    }

    /*
     * -------------------------------------------------------
     * Clean Shopify form parameters after success
     *
     * Prevents customer_posted=true from remaining
     * in the browser URL after the success view.
     * -------------------------------------------------------
     */
    function cleanNewsletterUrl() {
      if (
        !window.history ||
        !window.history.replaceState
      ) {
        return;
      }

      try {
        var url =
          new URL(
            window.location.href
          );

        if (
          url.searchParams.has(
            'customer_posted'
          ) ||
          url.hash === '#contact_form'
        ) {
          url.searchParams.delete(
            'customer_posted'
          );

          url.hash = '';

          var cleanUrl =
            url.pathname +
            (
              url.searchParams.toString()
                ? '?' +
                  url.searchParams.toString()
                : ''
            );

          window.history.replaceState(
            {},
            document.title,
            cleanUrl
          );
        }
      } catch (e) {}
    }
  }

  /*
   * ---------------------------------------------------------
   * Init
   * ---------------------------------------------------------
   */
  if (
    document.readyState === 'loading'
  ) {
    document.addEventListener(
      'DOMContentLoaded',
      init
    );
  } else {
    init();
  }

  /*
   * Shopify theme editor support.
   */
  document.addEventListener(
    'shopify:section:load',
    function () {
      init();
    }
  );
})();